import { gsap } from "gsap";
import DefaultBlock from "/scripts/default/block";

export default class AccordionRow extends DefaultBlock {
	init() {
		this.DOM = {
			content: this.block.querySelector(".accordion-row__answer"),
			inner: this.block.querySelector(".accordion-row__answer-inner"),
			path: this.block.querySelector(".accordion-plus__line-2"),
		};

		this.state = { open: false };

		this.block.addEventListener("click", () =>
			this.state.open === false ? this.innerOpen() : this.innerClose()
		);

		gsap.set(this.DOM.content, { height: 0 });
	}

	innerOpen() {
		this.state = { open: true };
		const newHeight = this.DOM.inner.scrollHeight;

		this.DOM.content.setAttribute("aria-hidden", false);

		gsap.to(this.DOM.content, {
			height: newHeight + "px",
			duration: 0.6,
			ease: "power3.inOut",
			clearProps: true,
		});
		gsap.to(this.DOM.path, {
			scaleY: 0,
			transformOrigin: "center",
			duration: 0.4,
			ease: "power3.inOut",
		});
	}

	innerClose() {
		this.state = { open: false };

		this.DOM.content.setAttribute("aria-hidden", true);

		gsap.to(this.DOM.content, {
			height: 0 + "px",
			duration: 0.6,
			ease: "power3.inOut",
		});
		gsap.to(this.DOM.path, {
			scaleY: 1,
			transformOrigin: "center",
			duration: 0.4,
			ease: "power3.inOut",
		});
	}
}
